import React from "react";
import _ from "underscore";

import { AutoCompleteInput, Form, IAutoCompleteOption, TextInput } from "armstrong-react";
import { Col, Grid, Row } from "armstrong-react-fix";
import { api } from "../../api/system/apiClient";
import { DatePicker } from "../datePicker";

import "./travellerDetailsForm.scss";

interface INewTravelerDetailsFormProps extends React.Props<NewTravelerDetailsForm> {
  data: INewTravelerDetailsInput;
  save: (traveler: INewTravelerDetailsInput) => void;
}

export class NewTravelerDetailsForm extends React.Component<INewTravelerDetailsFormProps, { }> {
  public updateTitle(title: Title) {
    this.props.data.title = title;
    if (title !== "other"){
      this.props.data.otherTitle = null;
    }
    this.forceUpdate();
  }
  public updateDate(propName: string, date: IDate) {
    this.props.data[propName] = date;
    this.forceUpdate();
  }
  public getSelectedCountry(prop: string): IAutoCompleteOption {
    if (this.props.data[prop]) {
      const country = this.props.data[prop] as IIsoCountry;
      return { id: country.id, name: country.name, data: country };
    }
    return null;
  }
  public updatePassportCountry(country: IIsoCountry) {
    this.props.data.passportIssuingCountryId = country.id;
    this.forceUpdate();
  }
  public save(){
    this.props.save(this.props.data);
  }
  public render() {
    const titles = [
      { value: "mr", name: "Mr" },
      { value: "mrs", name: "Mrs" },
      { value: "master", name: "Master" },
      { value: "miss", name: "Miss" },
      { value: "ms", name: "Ms" },
      { value: "dr", name: "Dr" },
      { value: "other", name: "Other" }];
    return <Form dataBinder={Form.jsonDataBinder(this.props.data) } onDataChanged={() => this.forceUpdate() }>
      <Grid className="grid-p-inner-xsmall rs-small-spaced">
        <Row className="needs-pad">
          <Col width="auto">
            <label>Title</label>
            <select onChange={(e) => this.updateTitle(e.target.value as Title) } defaultValue={this.props.data.title || ""}>
              <option value="" disabled={true}>title...</option>
              {titles.map(t => <option value={t.value}>{t.name}</option>) }
            </select>
          </Col>
          {this.props.data.title === "other" && <Col>
            <label>Other title</label>
            <TextInput {...Form.Bind.text("otherTitle") } placeholder="title..." />
          </Col>
          }
          <Col>
            <label>First name</label>
            <TextInput {...Form.Bind.text("firstName") } placeholder="first name..." />
          </Col>
          <Col>
            <label>Last name</label>
            <TextInput {...Form.Bind.text("lastName") } placeholder="last name..." />
          </Col>
        </Row>
        <Row>
          <Col className="sub-form col-dob">
            <label>Date of birth</label>
            <DatePicker date={this.props.data.dateOfBirth} onChange={(d) => this.updateDate("dateOfBirth", d)} />
          </Col>
        </Row>
        <Row>
          <Col className="col-passport">
            <label>Passport issuing country</label>
            <AutoCompleteInput placeholder="Start typing to filter..."
              value={this.getSelectedCountry("passportIssuingCountry")}
              className="m-bottom-small m-top-xxsmall"
              remoteQueryOnOpen={true}
              remoteThrottle={100}
              onSelected={(item: IAutoCompleteOption) => this.updatePassportCountry(item.data as IIsoCountry)}
              remoteQuery={(input) => api.getIsoCountries(input, null).then((cs) => _.map(cs.json.payload, l => ({ id: l.id, name: l.name, data: l })))} />
          </Col>
        </Row>
      </Grid>
    </Form>;
  }
}
